import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-enterprise";

type Props = EditableCallbackParams;

const useStyles = makeStyles((theme) =>
	createStyles({
		input: {
			"&:focus::placeholder": {
				color: "transparent !important",
			},
		},
	}),
);

export const LOTONameColumn = ({ data }: Props) => {
	const classes = useStyles();
	const {
		state: { LOTONameToLink },
		actions: { setLOTONameToLink },
	} = useWorkOrderModalsContext();

	const handleChangeLOTONameChange = (e: any) => {
		setLOTONameToLink(e.target.value.toUpperCase());
	};

	if (data.id === -1) {
		return (
			<Grid
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 152,
						maxWidth: 152,
						marginRight: "10px",
					}}
					value={LOTONameToLink}
					onChange={handleChangeLOTONameChange}
					placeholder={"Enter a name for LOTO"}
					className={classes.input}
					autoComplete="false"
				/>
			</Grid>
		);
	} else return data?.LOTOName;
};
